/* eslint-disable react/no-unescaped-entities,react/prop-types */
import Zdorovru from '../src/components/Pages/Company/About/Zdorovru'
import MobileDetect from 'mobile-detect'
import React from 'react'
import Head from 'next/head'
import MobileHeader from '@mobileShared/MobileHeader/MobileHeader'
import { createGSSP, pageStarted } from 'src/pages/shared/bindings'

export default function ZdorovruIndex(props) {
    return (
        <React.Fragment>
            <Head>
                <title>ООО "ЗДОРОВ.ру" - сеть аптек ЗДОРОВ.ру</title>
            </Head>
            {props.mobile && <MobileHeader>ООО "ЗДОРОВ.ру"</MobileHeader>}
            <Zdorovru isMobile={props.mobile} />
        </React.Fragment>
    )
}
export const getServerSideProps = createGSSP({
    pageEvent: pageStarted,
    async customize({ context }) {
        const md = new MobileDetect(context.req.headers['user-agent'])
        return {
            props: {
                mobile: md.mobile()
            }
        }
    }
})
